import { css, styled } from 'app/pages/request-single-page/components-v4/theme';
import { MediaFileProps } from '../../media-file.types';

export const VideoBadge = styled.div<{ $mode: MediaFileProps['mode'] }>`
  ${({ theme, $mode }) => css`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings.xs};
    min-height: ${$mode === 'thumbnail' ? '24px' : '32px'};
    padding-inline: ${theme.spacings.s};
    background-color: ${theme.colors.gray[100]};
    border-radius: ${theme.radiuses.xxs};
    ${$mode === 'thumbnail' &&
    css`
      transform: translate(50%, -50%);
    `}
  `}
`;
